import React from 'react'
import injectSheet from 'react-jss'
import style from 'components/Camera/style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MarkerWithLabel from 'markerWithLabel'
import { multiImagerIconPath, outlineLockIconPath } from 'components/Camera/helpers/iconPaths'

class Marker extends React.Component {
  componentWillMount() {
    const { addToMarkers, position, map, color, locked, name, id, showSimpleCameraIcon, drawingWire, classes } = this.props

    this.marker = new MarkerWithLabel({
      export: EXPORT,
      position: position,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        strokeWeight: 2,
        strokeColor: '#ffffff',
        strokeOpacity: 0.75,
        scale: 18,
        fillColor: color,
        fillOpacity: 0.75
      },
      raiseOnDrag: false,
      labelContent: name,
      labelVisible: false,
      labelAnchor: new google.maps.Point(-10, 0),
      labelClass: classes.cameraLabel,
      labelStyle: { opacity: 0.75 },
      draggable: !locked && !drawingWire,
      zIndex: 0,
      map
    })

    google.maps.event.addDomListener(this.marker, 'dragend', e => {
      this.props.updateCalculatorAction(e.latLng, 'location', id, true)
      this.props.lensIds.forEach(lensId => this.props.updateCalculatorAction(e.latLng, 'location', lensId, true))
      this.props.setDragging(false)
    })

    google.maps.event.addDomListener(this.marker, 'dragstart', _ => this.props.setDragging(true))

    this.markerOutline = new google.maps.Marker({
      position: position,
      icon: {
        path: locked ? outlineLockIconPath : multiImagerIconPath,
        strokeWeight: 0,
        strokeColor: '#ffffff',
        scale: 0.5,
        fillColor: '#ffffff',
        fillOpacity: 0.7,
        anchor: new google.maps.Point(-148, 110)
      },
      visible: locked || !showSimpleCameraIcon,
      clickable: false,
      draggable: false,
      zIndex: 1,
      map
    })

    addToMarkers('camera', this.marker)
    addToMarkers('cameraOutline', this.markerOutline)
  }

  componentDidMount() {
    const { messageAction } = this.props

    this.marker.addListener('mouseover', _ => this.marker.set('labelVisible', true))
    this.marker.addListener('mouseout', _ => this.marker.set('labelVisible', false))
    this.marker.addListener('mousedown', _ => this.props.locked && messageAction('generalError', 'This camera is locked. Right click to unlock.'))
  }

  componentWillReceiveProps({ position, color, locked, name, showSimpleCameraIcon, drawingWire }) {
    if (this.props.position.lat() !== position.lat() || this.props.position.lng() !== position.lng()) {
      this.updateIconPosition(position)
    }

    if (locked !== this.props.locked && !EXPORT) {
      const newIcon = this.markerOutline.getIcon()
      newIcon.path = locked ? outlineLockIconPath : multiImagerIconPath
      this.marker.setOptions({ draggable: !locked && !drawingWire })
      this.markerOutline.setOptions({
        icon: newIcon,
        visible: locked || !showSimpleCameraIcon
      })
    }

    if (drawingWire !== this.props.drawingWire) this.marker.setOptions({ draggable: !locked && !drawingWire })

    if (color !== this.props.color) this.updateIconColor(color)
    if (name !== this.props.name) this.marker.set('labelContent', name)
    if (showSimpleCameraIcon !== this.props.showSimpleCameraIcon) this.markerOutline.setOptions({ visible: locked || !showSimpleCameraIcon })
  }

  updateIconPosition(position) {
    this.marker.setPosition(position)
    this.markerOutline.setPosition(position)
  }

  updateIconColor(color) {
    const newIcon = this.marker.getIcon()
    newIcon.fillColor = color
    this.marker.set('icon', newIcon)
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}

export default injectSheet(style)(Marker)



// WEBPACK FOOTER //
// ./src/components/MultiImager/marker.js